import { dark } from './dark';
import { light } from './light';

export const themes = {
  light: light,
  dark: dark,
};

export type ThemeNames = 'light' | 'dark';